import React from 'react'

const Pdf404 = () => {
  return (
    <div className='rpannel-compo'>
      <h1>404: Page Not Found</h1>
    </div>
  )
}

export default Pdf404